import React from "react";
import { Card, CardBody, Box, CardFooter, Text } from "grommet";
import ParallaxTilt from "../components/ParallaxTilt2";
import { Faction } from "../FactionsHome";

interface Props {
    faction: Faction;
    onClick: () => void;
    active: boolean;
    width: string;
    height: string;
    showText: boolean;
    showImage: boolean;
}

const FactionView = ({ faction, onClick, active, width, height, showText, showImage }: Props) => {
    const [hover, setHover] = React.useState(false);
    return (
        <>
            <ParallaxTilt tilt={!active} style={{ backgroundImage: showImage && "url(" + "/api/images/" + faction.imageID + ")", backgroundColor: "background" }} onClick={onClick}>
                <Card width={width} height={height} onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)}>
                    <CardBody align="center" justify="center">
                        {(showText || hover) && (
                            <Box align="center" fill pad="small" justify="center" background={{ color: "background", opacity: 0.8 }} gap="small">
                                <Text size="small">{faction.description}</Text>
                                <Text size="small">{faction.strategy}</Text>
                            </Box>
                        )}
                    </CardBody>
                    <CardFooter pad="small" justify="center" align="end" background={active ? "brand" : "background-front"}>
                        <Text textAlign="center"> {faction.name}</Text>
                    </CardFooter>
                </Card>
            </ParallaxTilt>
        </>
    );
};

export default FactionView;
